import { useState } from 'react';
import { useCalendarApi } from 'src/api/useCalendarApi';
import { useAppDispatch } from 'src/redux/store';
import { enqueteCalendarSlice } from '../store/enqueteCalendarSlice';
// リマインドデータエンティティ
export interface ReminderEntity {
  // ID
  id?: string;
  // カレンダーのId
  calendarId?: string;
  // リマインドのメールアドレス
  reminderUserId: string;
  // リマインド宛先名（日本語）
  reminderNameJpn: string;
  // リマインド宛先名（英語）
  reminderNameEng?: string;
  // リマインド宛先のメールアドレス
  reminderAddress: string;
  // リマインド宛先のBluePageメールアドレス
  reminderBluePageEmailAddress: string;
  // 送信日付
  sentAt?: string;
  // リマインドステータス
  status: string;
  // 作成者
  createdBy?: string;
  // 作成日時
  createdAt?: string;
  // 更新者
  updatedBy?: string;
  // 更新日時
  updatedAt?: string;
  // 削除フラグ
  isDeleted?: boolean;
  // 更新フラグ
  updateFlag?: boolean;
  // 追加行key
  addRowNum?: Number;
}

export const useReminderListGrid = () => {
  // Redux dispatch 関数を取得
  const dispatch = useAppDispatch();
  // カレンダー関連データ取得 API
  const enqCalendarListApi = useCalendarApi();
  //ローディング
  const [isLoading, setIsLoading] = useState<boolean>(false);

  /**
   * リマインドデータ取得
   */
  const getReminderList = async (id: string) => {
    //ローディング開始
    setIsLoading(true);
    // リマインドデータ取得
    const reminderList = await enqCalendarListApi.getReminderList(id);
    if (reminderList === undefined) {
      return 1;
    }
    // リマインドデータの初期化
    dispatch(enqueteCalendarSlice.actions.setReminderListData(reminderList));
    //ローディング終了
    setIsLoading(false);
    return reminderList;
  };

  return { isLoading, getReminderList };
};
